// this doesn’t show on web but if not exist web won’t allow to render image directly
import React, { useMemo } from 'react';
import { View } from 'react-native';
import TouchableBounce from 'utils/packages/TouchableBounce';
import Text from 'design-system/Text';
import { CardView, rem, Spacer } from 'design-system';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import FastImage from 'utils/packages/rnFastImage';
import useColorScheme from 'hooks/useColorScheme';
const IMAGE_SIZE = rem(64);
const IMAGE_BORDER_RADIUS = rem(12);
const CARD_INTERNAL_PADDING = rem(16);
const walkthroughIcons = {
    save: require('./img/walkthrough-icon-save@2x.png'),
    emma: require('./img/walkthrough-icon-emma@2x.png'),
    invest: require('./img/walkthrough-icon-invest@2x.png'),
};
const walkthroughIconsDark = {
    save: require('./img/walkthrough-icon-save-dark@2x.png'),
    emma: require('./img/walkthrough-icon-emma-dark@2x.png'),
    invest: require('./img/walkthrough-icon-invest-dark@2x.png'),
};
const LearnWalkthroughCard = ({ data, onPress, contentContainerStyle, }) => {
    const styles = useStyles(styleSet);
    const colorScheme = useColorScheme();
    const content = useMemo(() => (<View style={styles.contentContainer}>
        <View style={styles.flex}>
          <Text Text-14 numberOfLines={2}>
            {data.title}
          </Text>
          <Spacer.H4 />
          <Text TextThin-14 Secondary>
            {data.subtitle}
          </Text>
        </View>
        <Spacer.W16 />
        <View style={styles.imageContainer}>
          <FastImage style={styles.image} source={colorScheme === 'dark'
            ? walkthroughIconsDark[data.icon]
            : walkthroughIcons[data.icon]}/>
        </View>
      </View>), [
        data.title,
        data.subtitle,
        data.icon,
        styles.contentContainer,
        styles.flex,
        styles.imageContainer,
        colorScheme,
        styles.image,
    ]);
    return (<View style={contentContainerStyle}>
      <Spacer h={16}/>
      <TouchableBounce onPress={onPress}>
        <CardView noMargin>
          <View style={styles.containerForList}>{content}</View>
        </CardView>
      </TouchableBounce>
    </View>);
};
const styleSet = createStyleSheets((colors) => ({
    containerForList: {
        margin: 0,
        padding: CARD_INTERNAL_PADDING,
        flexDirection: 'row',
    },
    contentContainer: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
    },
    flex: {
        flex: 1,
    },
    imageContainer: {
        alignItems: 'center',
        width: rem(IMAGE_SIZE),
        height: rem(IMAGE_SIZE),
        justifyContent: 'center',
        borderRadius: IMAGE_BORDER_RADIUS,
        backgroundColor: colors.cards.transparentOnDark,
    },
    image: {
        width: '100%',
        height: '100%',
    },
}));
export default LearnWalkthroughCard;
